import {Injectable} from '@angular/core';
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest} from '@angular/common/http';
import { Observable } from "rxjs/internal/Observable";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = localStorage.getItem("token");
        if(token) {
            const authReq = req.clone({headers: req.headers.set('Authorization', 'Bearer ' + token)});
            return next.handle(authReq);
        }else {
            return next.handle(req);
        }
    }

}

